export enum dashboardTabs {
  home = "home",
  estimateDetails = "estimate",
  bookingDetail = "booking",
  repairTracker = "repairTracker",
  estimateFeedback = "estimateFeedback",
  flowGetter = "flowGetter",
  referals = "referals",
  report = "report",
}